import React, { useEffect, useState } from 'react'
import {
    Card,
    CardContent,
    Grid,
    makeStyles,
    Button
} from '@material-ui/core'
import { connect } from 'react-redux'
import { PlayButtonWhite } from '../../../components/icons';
import PhoneImg from '../../../assets/diesel-card-phone-img.png';

const useStyles = makeStyles((theme) => ({

    cardV1: {
        width: '100%',
        borderRadius: 8,
        boxShadow: 'none'
    },
    watchVideoButton: {
        borderRadius: 16,
        backgroundColor: '#e77258',
        color: 'white !important',
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        padding: '3px 8px',
        marginTop: -14,
        marginLeft: 26,
        textTransform: 'none !important',
        boxShadow: 'none !imporant',
        '&:hover': {
            backgroundColor: '#e77258'
        }

    },
    mlV1: {
        marginLeft: 4
    },
    cardContentV1: {
        paddingTop: '18px !important',
        paddingBottom: '0px !important',
        paddingLeft: 24,
        paddingRight: 0
    },
    imgV1: {
        marginTop: '-8px'
    },
    bannerText: {
        fontSize: 18,
        marginLeft: 26,
        marginTop: 8
    },
    fwBold: {
        fontWeight: 'bold'
    },
    bannerFooter: {
        backgroundImage: "linear-gradient(to left, #ffd9d9 50%, #fff)",
        height: '36%',
        zIndex: 1000,
    },
    ml26: {
        marginLeft: 26
    },
    mt16: {
        marginTop: 16
    },
    divContainer: {
        marginTop: 16,
        marginLeft: 26
    }

}))

const Banner = ({ user }) => {

    const [dieselCardConfig, setDieselCardConfig] = useState({});

    const classes = useStyles()

    useEffect(() => {

        if (user && user.fuelCardConfig) {
            setDieselCardConfig(user.fuelCardConfig)
        }

    }, [user.fuelCardConfig]);


    return (
        <>
            <Card className={classes.cardV1}>
                <CardContent className={classes.cardContentV1}>
                    <Grid container direction="row" wrap="nowrap">
                        <Grid item>
                            <img src={PhoneImg} className={classes.imgV1} />
                        </Grid>
                        <Grid container direction="column" justify='space-between'>
                            <Grid item>
                                <div className={classes.bannerText}>{dieselCardConfig && dieselCardConfig.listing_page_text ? dieselCardConfig.listing_page_text : ""}</div>
                            </Grid>
                            <Grid item className={classes.bannerFooter}>
                                <Button className={classes.watchVideoButton} href={"https://www.youtube.com/embed/" + (dieselCardConfig && dieselCardConfig.education_page_video && dieselCardConfig.education_page_video.video_url ? dieselCardConfig.education_page_video.video_url : "")} target="_blank">
                                    <PlayButtonWhite />
                                    <span className={classes.mlV1}>Watch video</span>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )

}

const mapStateToProps = (state) => ({ user: state.user })
const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
